import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ShieldAlertIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const {
    scrollY
  } = useScroll();
  const bgOpacity = useTransform(scrollY, [0, 100], [0, 0.9]);
  const backdropBlur = useTransform(scrollY, [0, 100], ['blur(0px)', 'blur(12px)']);
  const borderOpacity = useTransform(scrollY, [0, 100], [0, 0.1]);
  return <motion.nav style={{
    backgroundColor: useTransform(bgOpacity, v => `rgba(10, 10, 10, ${v})`),
    backdropFilter: backdropBlur,
    borderBottom: useTransform(borderOpacity, v => `1px solid rgba(255, 255, 255, ${v})`)
  }} className="fixed top-0 left-0 right-0 z-50 h-16 flex items-center justify-center px-4 md:px-6" data-id="element-108">
      <div className="w-full max-w-5xl flex items-center justify-between" data-id="element-109">
        <div className="flex items-center gap-2 text-amber-500" data-id="element-110">
          <ShieldAlertIcon className="w-6 h-6" data-id="element-111" />
          <span className="font-bold text-lg tracking-tight text-white" data-id="element-112">
            ALQUILÁ<span className="text-amber-500" data-id="element-113">SEGURO</span>
          </span>
        </div>

        <Button variant="outline" size="sm" className="hidden sm:flex" data-id="element-114">
          Descargar Kit
        </Button>
      </div>
    </motion.nav>;
}